module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fullwidth",
    attrs: {
      "id": "main"
    }
  }, [_c('div', {
    staticClass: "jumbotron",
    attrs: {
      "id": "jumbo"
    }
  }, [_c('h2', [_vm._v("A modern vSphere client")]), _c('h3', [_vm._v("Inspired by RethinkDB")]), _c('a', {
    staticClass: "btn btn-lg btn-primary",
    attrs: {
      "id": "gitbutton",
      "href": "https://github.com/bhoriuchi/vsphere-connect"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-code"
  }), _c('span', [_vm._v(" Code on GitHub")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0539953a"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main.vue
// module id = 165
// module chunks = 1